import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import {
  PerformanceStore,
  usePerformanceActions,
  useCurrentWorkspaceId,
  PERFORMANCE_EXTRACTION_STATUS,
} from 'src/store';
import { captureMessage } from 'src/utils/lib/sentry';
import { connectedAccountsRequests } from 'src/graphql/performance';
import { alignChannelFromBackend } from 'src/data/channel';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'connectedAccountsFetched',
  'selectedAccountIds',
  'extractingCopies',
]);

export const useGetIntegrationsLastExtractionForDocument = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();
  const { connectedAccountsFetched } = usePerformanceState();

  useEffect(() => {
    if (!connectedAccountsFetched) {
      return;
    }

    connectedAccountsRequests(currentWorkspaceId).then((results) => {
      results?.forEach((result) => {
        if (!result.requests?.length) {
          return;
        }
        const channel = alignChannelFromBackend(result.channel);
        if (result.requests[0].status === PERFORMANCE_EXTRACTION_STATUS.running && channel) {
          performanceActions.getChannelLastExtraction(channel).catch((error) => {
            captureMessage('Error getting integration last extraction', {
              level: 'warning',
              extra: {
                error: error.toString(),
                source: 'useGetIntegrationsLastExtractionForDocument',
              },
            });
          });
        }
      });
    });
  }, [connectedAccountsFetched, performanceActions, currentWorkspaceId]);
};
